import { SharingType } from "@/components/Sharing";
import { getDocumentUrl } from "@/config";
import { Interaction } from "@/service/Model";
import TrackingService from "@/service/Tracking";

export const getSharingTitle = (interaction: Interaction): string => {
  return interaction.sharingTitle || interaction.title;
};

export const handleShare = (
  sharingType: SharingType,
  sharingTitle: string,
  twitterHandle?: string
): void => {
  switch (sharingType) {
    case SharingType.twitter:
      TrackingService.getInstance().trackOnSocialClick(SharingType.twitter);
      openTwitterPopup(sharingTitle, twitterHandle);
      break;
    case SharingType.facebook:
      TrackingService.getInstance().trackOnSocialClick(SharingType.facebook);
      openFacebookPopup(sharingTitle);
      break;
    case SharingType.whatsApp:
      TrackingService.getInstance().trackOnSocialClick(SharingType.whatsApp);
      openWhatsApp(sharingTitle);
      break;
    default:
  }
};

export function openFacebookPopup(title: string): void {
  openPopup(getFacebookShareUrl(title));
}

export function openTwitterPopup(title: string, twitterHandle?: string): void {
  openPopup(getTwitterShareUrl(title, twitterHandle));
}

export function openWhatsApp(title: string): void {
  window.open(getWhatsappShareUrl(title), "_blank");
}

function openPopup(url: string): void {
  window.open(
    url,
    "_blank",
    "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=600,width=600,height=400"
  );
}

export function getFacebookShareUrl(title: string): string {
  const quote = encodeURIComponent(title);
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    getDocumentUrl()
  )}&quote=${quote}`;
}

export function getTwitterShareUrl(
  title: string,
  twitterHandle?: string
): string {
  const text = encodeURIComponent(title);
  let url = `https://twitter.com/share?url=${encodeURIComponent(
    getDocumentUrl()
  )}&text=${text}`;
  if (twitterHandle) {
    url += `&via=${twitterHandle}`;
  }
  return url;
}

export function getWhatsappShareUrl(title: string): string {
  const text = encodeURIComponent(title + " - " + getDocumentUrl());
  return `whatsapp://send?text=${text}`;
}
